import { useQuery } from "@tanstack/react-query"
import { getWidgetConfigurationQuery } from "modules/campaigns/lib/templates/widget/getWidgetConfigurationQuery"

export function useGetWidgetConfigurationQuery(
  ...args: Parameters<typeof getWidgetConfigurationQuery>
) {
  return useQuery(getWidgetConfigurationQuery(...args))
}
